/**
 * Moduł do zarządzania sekcją "Twoje dane"
 */
app.service('deliveryUserInfoDetails', function (orderConfig, orderClass, validate, broker) {

	let $self, $operatorNoEmailCheckbox, $operatorUserEmail;
	let config,
		isOneInit = false;

	function init($deliveryForm) {
		config = orderConfig.getData();

		setElements($deliveryForm);

		if (!$self.length) {
			return;
		}

		setEvents();
	}

	function setElements($deliveryForm) {
		$self = $deliveryForm.find('#user-info-details');
		$operatorNoEmailCheckbox = $deliveryForm.find('#no-email');
		$operatorUserEmail = $deliveryForm.find('#e-mail');
	}

	function setEvents() {

		$operatorNoEmailCheckbox.on('click', function () {
			const noEmailChecked = $(this).is(':checked');
			toggleEmail(noEmailChecked);
			render();
		});

		if (!isOneInit) {
			isOneInit = true;

			broker.on('DELIVERY_FRONT_USER_TYPE_CHANGED', onFrontUserTypeChanged);
		}
	}

	function onFrontUserTypeChanged() {

		config.operatorClientEmailRequired = config.deliveryInfo.frontUserType === 'COMPANY';

		if (config.operatorClientEmailRequired) {
			toggleEmail(false);
		}

		render();
	}

	function toggleEmail(noEmailChecked) {

		config.operatorClientNoMail = noEmailChecked;
	}

	function setFieldState($field, shouldBeIgnored) {
		if ($field.hasClass('ignore') !== shouldBeIgnored) {
			$field.ignore(shouldBeIgnored).prop('disabled', shouldBeIgnored);
		}
	}

	function render() {

		orderClass.toggle('operator-email-required', config.operatorClientEmailRequired);
		orderClass.toggle('operator-no-email', config.operatorClientNoMail);

		$operatorNoEmailCheckbox.prop('checked', config.operatorClientNoMail);

		updateValidation();
	}

	function updateValidation() {
		setFieldState($operatorUserEmail, config.operatorClientNoMail);
		setFieldState($operatorNoEmailCheckbox, config.operatorClientEmailRequired);
	}

	return {
		init,
		render
	};
});